import { render } from "./CampaignManageCreatePage.vue?vue&type=template&id=1b1c5d98&lang=true"
import script from "./CampaignManageCreatePage.vue?vue&type=script&lang=js"
export * from "./CampaignManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__